export default __webpack_public_path__ + "static/media/Path2266.33ebfee0.svg";